import { useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { usePageHeader } from "@/hooks/usePageHeader";
import { AbsencesOvertimePanel } from "@/components/hr/AbsencesOvertimePanel";

export default function MyBalancePage() {
  const { personId } = useAuth();
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);

  usePageHeader({ title: "My Work" });

  if (!personId) {
    return (
      <div className="flex items-center justify-center py-12">
        <p className="text-muted-foreground">
          No employee profile linked to your account.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6 animate-fade-in">
      <AbsencesOvertimePanel
        personId={personId}
        year={year}
        onYearChange={setYear}
        showPayouts={false}
      />
    </div>
  );
}
